import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import { ExperienceInformationI } from "../interfaces/InformationInterface";
import LeetCodeIcon from "../components/SVGIcon/LeetCode";
const homepageInformation = {
  title: "Full-stack developer",
  urlImg:
    "https://lh3.googleusercontent.com/pw/ABLVV87CqdcnJavx7mviYvpexxijCKT2dPy_L3DZyMlHrDu8upFqtQ2VipS05A9Y4Ek-rDJTrwPcXIyGEZOw-0gKQr3l6ly1Vfim3daqNa9m_Lp4h3RgntlDPMMhRdNCOdqlyJAFvl6RASUtI0f5KqB_Eh_0=w1391-h928-s-no-gm?authuser=0",
  paragraph:
    "I'm a fullstack developer with expertise in Node.js. I have experience in building secure and reliable web applications using React. In addition to my proficiency in Node.js and React, I specialize in database management and optimization, employing SQL using MySQL and NoSQL using MongoDB to ensure efficient data handling.",
};
const aboutMeInformation = {
  title: "Hello, I'm Quan Giap\nI enjoy solving coding problems",
  urlImg: "me_pic.jpg",
  paragraph:
    "I have been doing self learn and create many projects about web-development. I easily get used to a new environments, leveraging my communication skills to work seamlessly within cross-functional teams. In my free time, I usually solve complex problems in LeetCode and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
};
const contacts = {
  title: "Get in Touch with Me",
  paragraph:
    "Thank you for taking the time to explore my portfolio! I'm thrilled that my work has captured your interest. Whether you have questions, feedback, or simply want to say hello, I'd love to hear from you. Feel free to reach out using the form below or connect with me through the provided contact information. Your message is important to me, and I'll do my best to respond as soon as possible. Looking forward to connecting with you!",
  website: [
    {
      name: "GitHub",
      url: "https://github.com/QuanGiap",
      icon: <GitHubIcon />,
    },
    {
      name: "LinkedLn",
      url: "https://www.linkedin.com/in/quan-giap-a3a0a1254/",
      icon: <LinkedInIcon />,
    },
    {
      name: "LeetCode",
      url: "https://leetcode.com/quangiap1711/",
      icon: LeetCodeIcon,
    },
  ],
  phoneNumber: "(240) 734-1633",
  gmail: "quangiap1711@gmail.com",
};
const experienceInformation: ExperienceInformationI = {
  article: {
    title: "Code Chronicles: Unveiling My Software Development Journey",
    urlImg: "",
    paragraph:
      "During my journey, I've tackled a range of projects that I'm proud of. Some were team efforts, while others I worked on independently. Not only I work on website development projects, I am also working on Unity projects. I sometime want to try out a new experience beside website developer",
  },
  unrelated_projects: [
    {
      projectTitle: "Games Projects",
      projects: [
        {
          title: "Tower defense",
          startDate: 1635724800000,
          endDate: 1641427200000,
          description:
            "I built a simple tower defense game just for fun. You can try playing it. The unique about this game is you actually can damage the enemy by clicking on them",
          url: "https://play.unity.com/en/games/251f2581-51fe-4cdb-a6f9-dd246689d794/tower-defense",
          miniDescription: "A simple tower defense",
          tools: "Unity",
          idImage: ['1etqFsTzGO-noLUAg2lEmJjU1kiyk96RD'],
          iconToolUrls: [
            "https://s3-symbol-logo.tradingview.com/unity--big.svg",
          ],
        },
        {
          title: "Shooting game",
          startDate: 1648944000000,
          endDate: 1651363200000,
          description:
            "I built another simple shooting game just for fun. In this game, you can buy and upgrade guns. The enemy will get stronger overtime. It will be best to keep stick to your favorite gun and upgrading it.",
          url: "https://play.unity.com/en/games/a34c18ae-b15d-40a1-8739-84badf0644c7/shooting-game",
          idImage: ['1kovhLYwRXcasumA84yZ_U9P_LvV8q1DF'],
          miniDescription: "A simple shooting game",
          tools: "Unity",
          iconToolUrls: [
            "https://s3-symbol-logo.tradingview.com/unity--big.svg",
          ],
        },
      ],
    },
  ],
  projects: [
    {
      title: "Quiz website | Front-end Develper",
      startDate: 1618444800000,
      endDate: 1618704000000,
      description:
        "I built a fun quiz website that's both entertaining and educational. It has different quizzes on lots of topics and difficulty levels. The website works well on any device and is easy to use. I made sure it's interactive and fun, so people can enjoy taking quizzes and share them with friends, creating a cool community around learning and having fun.",
      url: "https://quangiapquizsite.netlify.app/",
      idImage: [
        "1U7C5p0Z22nw9zz3mSnIqF0ePMe5pEO9b",
        "17lSH_-M98IT6XEv2Y_XfUGvohk6i5e_F",
      ],
      miniDescription: "A fun quiz website",
      tools: "React",
      iconToolUrls: [
        "https://lh3.googleusercontent.com/pw/ABLVV872NnxlKxxJYQOPMXt8gub-MJAWZBD-DHQ6fmnFKWmrE0tqKQ8Sywl82Xki5TEWLNFHlAfIn1X2WVOLq4sTQaJPNAvJKvkwXY2XVodU4ANWR1vLkDqcFILukWCpcFW-jsbfdWceP0hTAh8uGIJaF9W-=w320-h320-s-no-gm?authuser=0",
      ],
    },
    {
      title: "To-do task website | Fullstack Develper",
      startDate: 1628985600000,
      endDate: 1631664000000,
      description:
        "I led the creation of a user-friendly to-do website using React. It helps people make task lists and keeps track of deadlines. To keep user data safe, the user need to have token (receive from the sign in) to be able to modified the their data. The website's information is stored securely in a MongoDB database, making it reliable and able to handle lots of data while giving users an easy experience. It is a free version and simple project, it might take a little longer to load data from the backend for the first time. If you don't want to wait, you use the test version which is in the option.",
      url: "https://storied-mousse-48cf47.netlify.app",
      idImage: [
        "1VaMJh0JZyOtaMXnG6IuiWXGlDAKSuiCb",
        "1C2gpo8CiIAPRVa3RO-BfTYkVgtQ6JKf7",
        "1txlYDEgapV4H1vHUDuvfwwks-4HvSYT8",
      ],
      miniDescription:
        "A task website that allow user to create task with timer",
      tools: "React, MongoDB, Express API",
      iconToolUrls: [
        "https://lh3.googleusercontent.com/pw/ABLVV872NnxlKxxJYQOPMXt8gub-MJAWZBD-DHQ6fmnFKWmrE0tqKQ8Sywl82Xki5TEWLNFHlAfIn1X2WVOLq4sTQaJPNAvJKvkwXY2XVodU4ANWR1vLkDqcFILukWCpcFW-jsbfdWceP0hTAh8uGIJaF9W-=w320-h320-s-no-gm?authuser=0",
        "https://lh3.googleusercontent.com/pw/ABLVV86uyHlwNm_NxDirbtbNpsq7ZcewTfRf0Y0w8XbEZ2k4Ma39qffa2U0woG0np71AI0OSdOs07PGDuy_8twi06NK-6GX55nx3YT_H7jYrNFC-6-cqR5OZ2dAehvJR1hVzxCTvEDUuFHFLom2BP8DViZ1c=w320-h320-s-no-gm?authuser=0",
        "https://lh3.googleusercontent.com/pw/ABLVV85D_hccq4mmBF_Ly-n3ilUgYyHhLlcuDG9NKrd00-OIG5ZkactIstcqE9t99WfKljWyhuPnFyK7tK_HWMSwM1xREnyzyo1B0U9J7VwLIPL5tedWyJdHz68onqfXD2yQTgWAzsOSOa1W7jihlaU-F9TI=w32-h32-s-no-gm?authuser=0",
      ],
    },
    {
      title: "POS-Manager website | Front-end Develper",
      startDate: 1647302400000,
      endDate: 1692057600000,
      description:
        "A group project focused on building a React website for employee management. I created many reusable component like table, search bar, and button. I also created the fincance page where company can track the revenue, expenses, and payrolls \nWebsite was taken down",
      miniDescription:
        "A group project focused on building a React website for employee management",
        idImage: [
        "1g5FzyaE_wd5_oHH7cUCGYeQ9X5e-6Ys_",
        "12bISGnapzGBS-opXTM1zoS19Su4Mk3Yf",
      ],
      tools: "React",
      iconToolUrls: [
        "https://lh3.googleusercontent.com/pw/ABLVV872NnxlKxxJYQOPMXt8gub-MJAWZBD-DHQ6fmnFKWmrE0tqKQ8Sywl82Xki5TEWLNFHlAfIn1X2WVOLq4sTQaJPNAvJKvkwXY2XVodU4ANWR1vLkDqcFILukWCpcFW-jsbfdWceP0hTAh8uGIJaF9W-=w320-h320-s-no-gm?authuser=0",
      ],
    },
    {
      title: "V-Life website | Front-end Develper",
      startDate: 1652572800000,
      endDate: 1692057600000,
      description:
        "A group project focused on developing website to adventurous tourists seeking new experiences. I created reusable component search bar, button, and I created notification page and tourist page that can show recommend places for user \nThe app project was taken down",
      miniDescription:
        "A group project focused on developing website to adventurous tourists seeking new experiences",
        idImage: [
        "159Az04AEelgqQ5dULaAYBqfhOlKZPLbm",
        "1pkWdDj3-FQk6NDkknfvp595e79Oqp3_6",
      ],
      tools: "React native",
      iconToolUrls: [
        "https://lh3.googleusercontent.com/pw/ABLVV872NnxlKxxJYQOPMXt8gub-MJAWZBD-DHQ6fmnFKWmrE0tqKQ8Sywl82Xki5TEWLNFHlAfIn1X2WVOLq4sTQaJPNAvJKvkwXY2XVodU4ANWR1vLkDqcFILukWCpcFW-jsbfdWceP0hTAh8uGIJaF9W-=w320-h320-s-no-gm?authuser=0",
      ],
    },
  ],
  volunteers: [
    {
      title: "DemocracyLab",
      startDate: 1682899200000,
      endDate: 1707955200000,
      position: "Fullstack Develper",
      description: [
        "Resolved an issue in which the website redirected the project owner to an error page when attempting to accept new members to join the project.",
        'Removed the "react-helmet" component and restructured the project to allow other developers to modify header metadata through Django instead of React.',
        "Created function that prevent authenticated users from accessing pages intended for non-authenticated users.",
        "Added new GroupProject page and a new feature that allowed group owner managing projects.",
      ],
      url: "https://www.democracylab.org/",
      miniDescription:
        "This is a digital platform linking skilled volunteers with social impact projects, providing opportunities for individuals to apply their expertise towards meaningful cause.",
      urlIcon:
        "https://pbs.twimg.com/profile_images/999537348189667328/F2an4XFk_400x400.jpg",
      idImage:['1UWWXO2LKx6SVqrf1PG-bFZSkaV9OSX5r']
    },
    {
      title: "Greenstand",
      startDate: 1690848000000,
      endDate: 1717977600000,
      position: "Fullstack Develper",
      description: [
        "Fixed the bug where the user goes back to an unnecessary URL instead of the valid URL",
        "Improved the coordinates URL format by switching Bounding Coordinates to View Coordinates",
        "Added new feature that allow user to select multiple trees's data instead of one at time. It will help reduce more than 50% the amount of time needed to trade data with other user.",
      ],
      url: "https://greenstand.org/",
      miniDescription:
        "This website enables people to support global reforestation by sponsoring tree planting through an online platform. It promotes environmental sustainability and community development initiatives globally.",
      urlIcon: "https://greenstand.org/fileadmin/08-logos/logo_loader.svg",
      idImage:['1h23Sb6QWCDQWwfnafGwIGGTojHxx3hcO']
    },
    {
      title: "Amoeba",
      startDate: 1750291200000,
      position: "Fullstack Develper",
      description: [
        "Enhanced system logging and performance, adding detailed user activity tracking across website and server, and reducing data load time by 82%.",
        "Developed and secured Webhook integration, , enabling real-time server-website communication",
        "Built an API that compares client and capital databases, highlights differences, and enables users to selectively apply updates, generate symbols/folders, and view changes in a web dashboard"
      ],
      url: "https://www.amoeba-software.com/",
      miniDescription:
        "Amoeba is an engineering and software consultancy that streamlines electronic component library creation for Automotive, Aerospace, Defense, and Transportation industries. Their AI-powered platform generates accurate CAD-formatted data, reduces lead times, and improves collaboration.",
      urlIcon: "https://yt3.googleusercontent.com/fxTZgvi3nsI-Han8Y7h8fAXYJrgefE0RcrxXA9ib8_pVn6Ym95shrlgreJoSdOaFwMjTK-3Txw=s160-c-k-c0x00ffffff-no-rj",
      idImage:[]
    },
  ],
};
const profileUrl =
  "https://lh3.googleusercontent.com/pw/AP1GczOV-bEVPWSvOaFJSEXwEymthJhQKnTwtU6KeSF7681tO8mU59TsH7HN-J_2oM2CreX4dYx-ZV0GMLGBKwaWdxlLd9VL0nqngJ69ddqKnDNA7c9X8kVejGCLAlTPyMAo91qPBqSaNw7h_PwaEfP0oAX8=w128-h128-s-no-gm?authuser=0";
const resumeUrl =
  "https://drive.google.com/file/d/121I0t29sGaQru6AxuMJsXtzxS29DNUUy/view?usp=sharing";
const MINIMUM_CLIENT_WIDTH = 600;

export {
  MINIMUM_CLIENT_WIDTH,
  homepageInformation,
  profileUrl,
  contacts,
  experienceInformation,
  aboutMeInformation,
  resumeUrl,
};
